export class PersesFilters {
  status: string[] | undefined;
  responsibleIds: string[] | undefined;
  types: string[] | undefined;
  activityTypes: string[] | undefined;
  contacts: string[] | undefined;

  constructor(
    status: string[] | undefined,
    responsibles: string[] | undefined,
    types: string[] | undefined,
    activityTypes: string[] | undefined,
    contacts: string[] | undefined
  ) {
    this.status = status;
    this.responsibleIds = responsibles;
    this.types = types;
    this.activityTypes = activityTypes;
    this.contacts = contacts;
  }

  static Builder = class {
    private _status: string[] | undefined;
    private _responsibles: string[] | undefined;
    private _types: string[] | undefined;
    private _activityTypes: string[] | undefined;
    private _contacts: string[] | undefined;

    setStatus(status: string[]) {
      this._status = status;
      return this;
    }

    setResponsibles(responsibles: string[]) {
      this._responsibles = responsibles;
      return this;
    }

    setTypes(types: string[]) {
      this._types = types;
      return this;
    }

    setActivityTypes(activityTypes: string[]) {
      this._activityTypes = activityTypes;
      return this;
    }

    setContacts(contacts: string[]) {
      this._contacts = contacts;
      return this;
    }

    build() {
      return new PersesFilters(
        this._status,
        this._responsibles,
        this._types,
        this._activityTypes,
        this._contacts
      );
    }
  };
}

export class PersesOptions {
  aggregationTerm: string | undefined;
  range: { fromDate: string; toDate: string } | undefined;
  dateInterval: string | undefined;
  type: string | undefined;
  subAggregationTerm: string | undefined;

  constructor(
    aggregationTerm: string | undefined,
    range: { fromDate: string; toDate: string },
    type: string | undefined,
    subAggregationTerm: string | undefined,
    dateInterval: string | undefined
  ) {
    this.aggregationTerm = aggregationTerm;
    this.range = range;
    this.type = type;
    this.subAggregationTerm = subAggregationTerm;
    this.dateInterval = dateInterval;
  }

  static Builder = class {
    private _aggregationTerm: string | undefined;
    private _range: { fromDate: string; toDate: string } | undefined;
    private _dateInterval: string | undefined;
    private _type: string | undefined;
    private _subAggregationTerm: string | undefined;

    setAggregationTerm(aggregationTerm: string) {
      this._aggregationTerm = aggregationTerm;
      return this;
    }

    setRange(range: { fromDate: string; toDate: string }) {
      this._range = range;
      return this;
    }

    setDateInterval(dateInterval: string) {
      this._dateInterval = dateInterval;
      return this;
    }

    setType(type: string) {
      this._type = type;
      return this;
    }

    setSubAggregationTerm(subAggregationTerm: string) {
      this._subAggregationTerm = subAggregationTerm;
      return this;
    }

    build() {
      return new PersesOptions(
        this._aggregationTerm,
        this._range,
        this._type,
        this._subAggregationTerm,
        this._dateInterval
      );
    }
  };
}
export type PersesSearchRequestType = {
  filters: PersesFilters;
  options: PersesOptions;
};
